import { DateTime } from 'luxon';

export const dropsSettings = {
  data: [],
  isLoading: true,
  getCurrentTime: DateTime.now().toMillis(),
};
